import { Route, Routes } from "react-router-dom";
import Verify from "./Verify";
import Home from "./Home";

export default function Router() {
  return (
    <Routes>
      <Route path="/">
        <Route index element={<Home />} />
        <Route path={"/mastercard"} element={<Verify />} />
      </Route>
    </Routes>
  );
}
